import React, { useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Button } from '../ui/Button';
export function StickyHeader() {
  const {
    scrollY
  } = useScroll();
  const [hidden, setHidden] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useMotionValueEvent(scrollY, 'change', latest => {
    const previous = scrollY.getPrevious() ?? 0;
    setHidden(latest > previous && latest > 150);
    setIsScrolled(latest > 50);
  });
  return <motion.header variants={{
    visible: {
      y: 0
    },
    hidden: {
      y: '-100%'
    }
  }} animate={hidden ? 'hidden' : 'visible'} transition={{
    duration: 0.35,
    ease: 'easeInOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-canvas/90 backdrop-blur-md border-b border-line shadow-sm' : 'bg-transparent'}`} data-id="element-258" data-mp="1ubxuwkvlv0p9">
      <div className="container mx-auto px-4 py-3" data-id="element-259" data-mp="8ybix3so40us">
        <div className="flex items-center justify-between" data-id="element-260" data-mp="8vyss3crak6n">
          <div className="font-display font-bold text-xl tracking-tight text-pistachio-800 flex items-center gap-2" data-id="element-261" data-mp="1hm6mpeow9itz">
            <span aria-hidden="true" data-id="element-262" data-mp="1cnmx94b3dowv">🌿</span>
            <span className="hidden sm:inline" data-id="element-263" data-mp="1qllag6doffas">CLOSE THE GAP™</span>
          </div>

          <div className="flex items-center gap-4" data-id="element-264" data-mp="1qjgyd15mj9zf">
            <div className="hidden md:flex items-center gap-3 text-xs text-muted mr-4" data-id="element-265" data-mp="1llyw1tm43t0e">
              <span className="flex items-center gap-1" data-id="element-266" data-mp="20izd936og5km">
                <span aria-hidden="true" data-id="element-267" data-mp="1vkxvclkzmcaq">🛡️</span> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-268" data-mp="1vj3kk03fk0kd">
                <span aria-hidden="true" data-id="element-269" data-mp="29b9qyugs6t6m">🔒</span> Pago seguro
              </span>
            </div>
            <Button size="sm" href="#pricing" data-id="element-270" data-mp="25bsl3zxfzu0x">
              QUIERO MI MEGA PACK
            </Button>
          </div>
        </div>
      </div>
    </motion.header>;
}